<!-- ── PENDING: eligibility check ─────────────────────────────────────────── -->
<div *ngIf="epe.sop_status == 'pending'" class="action-panel">
  <div class="action-panel-header">Eligibility Check</div>
  <div class="action-panel-body">
    <p class="action-panel-desc">
      This EPE is in pending state and will stay so until a Call Manager evaluates it.
    </p>

    <div *ngIf="auth.isCallManager()" class="eligibility-row">
      <span class="eligibility-label" [class.is-eligible]="checked" [class.is-not-eligible]="!checked">
        {{ checked ? 'Eligible' : 'Not Eligible' }}
      </span>
      <label class="toggle-switch">
        <input type="checkbox" (change)="change()" [checked]="checked">
        <span class="toggle-slider"></span>
      </label>
    </div>

    <button *ngIf="auth.isCallManager()" (click)="submitEligibility()" class="btn btn-primary action-btn">
      Submit
    </button>
  </div>
</div>

<!-- ── NOT ELIGIBLE ───────────────────────────────────────────────────────── -->
<div *ngIf="epe.sop_status == 'not_eligible'" class="action-panel">
  <div class="action-panel-header">Evaluation Result</div>
  <div class="action-panel-body">
    <div class="status-badge-block">
      <span class="label label-danger status-label-lg">Not Eligible</span>
    </div>
    <p class="action-panel-desc">This EPE has been evaluated as not eligible.</p>
  </div>
</div>

<!-- ── ELIGIBLE: voting form ──────────────────────────────────────────────── -->
<div *ngIf="epe.sop_status == 'eligible'" class="action-panel">
  <div class="action-panel-header">Vote</div>
  <div class="action-panel-body">

    <div class="criterion">
      <div class="criterion-label">C1 — Roles & Years of Experience in TWGs (30%)</div>
      <div class="criterion-input-row">
        <input class="criterion-input" type="number" [ngModel]="vote.automatic" disabled>
        <span class="criterion-max">/ 10</span>
      </div>
    </div>

    <div class="criterion">
      <div class="criterion-label">C2 — TWG Participation (30%)</div>
      <div class="criterion-input-row">
        <input *ngIf="!votedByMe && auth.isProjectBoard()" min="0" max="10"
               [(ngModel)]="engagment" class="criterion-input" type="number">
        <input *ngIf="votedByMe || !auth.isProjectBoard()" min="0" max="10"
               [(ngModel)]="engagment" class="criterion-input" type="number" disabled>
        <span class="criterion-max">/ 10</span>
      </div>
    </div>

    <div class="criterion">
      <div class="criterion-label">C3 — Other Expertise & Professional Background (30%)</div>
      <div class="criterion-input-row">
        <input *ngIf="!votedByMe && auth.isProjectBoard()" min="0" max="10"
               [(ngModel)]="standardisation" class="criterion-input" type="number">
        <input *ngIf="votedByMe || !auth.isProjectBoard()" min="0" max="10"
               [(ngModel)]="standardisation" class="criterion-input" type="number" disabled>
        <span class="criterion-max">/ 10</span>
      </div>
    </div>

    <div class="criterion">
      <div class="criterion-label">C4 — Gender Balance (10%)</div>
      <div class="criterion-input-row">
        <input class="criterion-input" type="number" [ngModel]="vote.gender" disabled>
        <span class="criterion-max">/ 10</span>
      </div>
    </div>

    <div *ngIf="isWarning()" class="warning-block">
      <div *ngIf="epe.engVariance! >= 2" class="warning-item">
        <i class="fa fa-exclamation-triangle"></i> High variance on C2 votes.
      </div>
      <div *ngIf="epe.standVariance! >= 2" class="warning-item">
        <i class="fa fa-exclamation-triangle"></i> High variance on C3 votes.
      </div>
    </div>

    <vote-breakdown *ngIf="voteRows.length > 0 && (auth.isCallManager() || auth.isProjectBoard())"
                    [rows]="voteRows" [editable]="auth.isAdmin()"
                    (override)="overrideVote($event)">
    </vote-breakdown>

    <button *ngIf="auth.isProjectBoard() && !votedByMe"
            (click)="submitVote()" class="btn btn-primary action-btn">
      Submit Vote
    </button>
    <p *ngIf="auth.isProjectBoard() && votedByMe" class="already-voted-msg">
      <i class="fa fa-check-circle"></i> You already voted this EPE.
    </p>
    <button *ngIf="auth.isCallManager()"
            (click)="stopVote()" class="btn btn-default action-btn action-btn--secondary">
      Close Voting Session
    </button>

  </div>
</div>

<!-- ── VOTED: score summary ───────────────────────────────────────────────── -->
<div *ngIf="epe.sop_status == 'voted'" class="action-panel">
  <div class="action-panel-header">Vote Summary</div>
  <div class="action-panel-body">

    <div *ngIf="epe.score" class="final-score-block">
      <span class="final-score-num">{{ truncateFloat(epe.score) }}</span>
      <span class="final-score-label">/ 10 &nbsp;·&nbsp; {{ epe.nvotes }} vote{{ epe.nvotes !== 1 ? 's' : '' }}</span>
    </div>

    <div class="score-summary-grid">
      <div class="score-summary-row">
        <span class="score-summary-label" title="Roles & Years of Experience in TWGs (30%)">C1</span>
        <span class="score-summary-bar-wrap">
          <span class="score-summary-bar" [style.width.%]="(vote.automatic ?? 0) * 10"></span>
        </span>
        <span class="score-summary-val">{{ vote.automatic ?? '—' }}</span>
      </div>
      <div class="score-summary-row">
        <span class="score-summary-label" title="TWG Participation (30%)">C2</span>
        <span class="score-summary-bar-wrap">
          <span class="score-summary-bar" [style.width.%]="avgEngagement * 10"></span>
        </span>
        <span class="score-summary-val">{{ avgEngagement || '—' }}</span>
      </div>
      <div class="score-summary-row">
        <span class="score-summary-label" title="Other Expertise & Professional Background (30%)">C3</span>
        <span class="score-summary-bar-wrap">
          <span class="score-summary-bar" [style.width.%]="avgStandardisation * 10"></span>
        </span>
        <span class="score-summary-val">{{ avgStandardisation || '—' }}</span>
      </div>
      <div class="score-summary-row">
        <span class="score-summary-label" title="Gender Balance (10%)">C4</span>
        <span class="score-summary-bar-wrap">
          <span class="score-summary-bar" [style.width.%]="(vote.gender ?? 0) * 10"></span>
        </span>
        <span class="score-summary-val">{{ vote.gender ?? '—' }}</span>
      </div>
    </div>

    <div *ngIf="isWarning()" class="warning-block" style="margin-top: 10px;">
      <div *ngIf="epe.engVariance! >= 2" class="warning-item">
        <i class="fa fa-exclamation-triangle"></i> High variance on C2 votes.
      </div>
      <div *ngIf="epe.standVariance! >= 2" class="warning-item">
        <i class="fa fa-exclamation-triangle"></i> High variance on C3 votes.
      </div>
    </div>

    <vote-breakdown *ngIf="voteRows.length > 0 && (auth.isCallManager() || auth.isProjectBoard())"
                    style="margin-top: 12px; display: block;"
                    [rows]="voteRows" [editable]="auth.isAdmin()"
                    (override)="overrideVote($event)">
    </vote-breakdown>

  </div>
</div>

<!-- ── NOTE (call manager / project board, non-pending) ──────────────────── -->
<div *ngIf="epe.sop_status != 'pending' && (auth.isCallManager() || auth.isProjectBoard())"
     class="action-panel" style="margin-top: 12px;">
  <div class="action-panel-header">Internal Note</div>
  <div class="action-panel-body">
    <form (ngSubmit)="submitNote()" #noteForm="ngForm">
      <textarea class="form-control note-textarea"
                [(ngModel)]="note" name="note" rows="4"
                placeholder="Write a note about this EPE…"></textarea>
      <button type="submit" class="btn btn-default action-btn action-btn--secondary" style="margin-top:8px;">
        Save Note
      </button>
    </form>
  </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
